/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dashboard': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M77 39.668h33.332v25H77v-25zm0 70.832V68.832h33.332V110.5H77zm-37.5 0v-25h33.332v25H39.5zm0-29.168V39.668h33.332v41.664H39.5zm4.168-37.5v33.336h25V43.832h-25zm37.5 0V60.5h25V43.832h-25zm0 29.168v33.332h25V73h-25zm-37.5 16.668v16.664h25V89.668h-25z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
